import { EventEmitter, Injectable, Output } from '@angular/core';
import { MessageDto } from '../Dto/Shared/MessageDto';

/**
 * Služba pro komponenut s výpisem zpráv 'messages'.
 *
 */
@Injectable({
	providedIn: 'root',
})
export class PdsMessageService {
	
	constructor() {}

	/**
	 * Událpos pro přidání zprávy do komponenty messages.
	 */
	@Output() onAdd: EventEmitter<MessageDto | MessageDto[]> = new EventEmitter<MessageDto | MessageDto[]>();

	/**
	 * Událost pro promazání všech komponent messages.
	 */
	@Output() onClearAll: EventEmitter<any> = new EventEmitter();

	/**
	 * Událost promazání zpráv podle vybraného klíče.
	 */
	@Output() onClear: EventEmitter<string> = new EventEmitter<string>();

	/**
	 * Přidá zprávu do komponenty messages.
	 * @param messages { MessageDto | MessageDto[]}
	 */
	add(messages: MessageDto | MessageDto[]): void {
		if (messages != void 0) {
			this.onAdd.emit(messages);
		}
	}

	/**
	 * Vyčistí všechny zprávy.
	 */
	clearAll(): void {
		this.onClearAll.emit();
	}

	/**
	 * Vyčistí zprávy podle klíče.
	 * @param key {string} Klíč zprávy
	 */
	clear(key: string): void {
		if (key != void 0 && key != '') this.onClear.emit(key);
  }

  addErrors(key: string, messages: string[]): void {
    let msgs = messages?.map<MessageDto>(x => {
      return { key: key, severity: 'error', text: x, closable: true, icon: 'pi pi-times' };
    });

    if (msgs?.length > 0) this.onAdd.emit(msgs);
  }
}
